module.exports = __webpack_public_path__ + "images/videoCaseStudy-challenge-fbMock-empty.png?h=a238b8cce2fb371d8b37d9a6bbd3991d";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-challenge-fbMock-empty.png
// module id = 1603
// module chunks = 12 15